module.exports = __webpack_public_path__ + "static/media/02-2.1a907230.webp";